export default [
  {
    name: 'Start',
    scene: 'StartScene',
    view: 'StartView'
  },
  {
    name: 'Intro',
    scene: 'IntroScene',
    view: 'StoryView'
  },
  {
    name: 'SelectPlayer',
    scene: 'SelectPlayerScene',
    view: 'SelectPlayerView'
  },
  {
    name: 'SelectCharacter',
    scene: 'SelectCharacterScene',
    view: 'SelectCharacterView'
  },
  {
    name: 'SelectStory',
    scene: 'SelectStoryScene',
    view: 'SelectStoryView'
  },
  {
    name: 'Hallway',
    scene: 'HallwayScene',
    view: 'StoryView'
  },
  {
    name: 'Hospital',
    scene: 'HospitalScene',
    view: 'StoryView'
  },
  {
    name: 'Beach',
    scene: 'BeachScene',
    view: 'StoryView'
  },
  {
    name: 'City',
    scene: 'CityScene',
    view: 'StoryView'
  },
  {
    name: 'Country',
    scene: 'CountryScene',
    view: 'StoryView'
  },
  {
    name: 'Forest',
    scene: 'ForestScene',
    view: 'StoryView'
  },
  {
    name: 'Park',
    scene: 'ParkScene',
    view: 'StoryView'
  },
  {
    name: 'End',
    scene: 'EndScene',
    view: 'EndView'
  },
  {
    name: 'NotSupported',
    scene: null,
    view: 'NotSupportedView'
  }
]
